import React from 'react';

export const WebfontsContext = React.createContext();
